import { createStyles } from "@material-ui/core";
export var styles = function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return createStyles({
        root: (_b = {
                width: 517,
                borderRadius: 30,
                overflow: "hidden",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                backdropFilter: "blur(5px)",
                WebkitBackdropFilter: "blur(5px)",
                padding: "65px 65px 40px"
            },
            _b[breakpoints.down("xs")] = {
                width: "100%",
                borderRadius: 0,
                padding: "40px 24px 32px"
            },
            _b)
    });
};
